<template>
    <div id="login-page">
        <div class="page animsition vertical-align text-center sign-in-wrapper" data-animsition-in="fade-in" data-animsition-out="fade-out">
            <div class="page-content form-max-width vertical-align-middle">
                <div class="brand">
                    <a href="http://www.trackado.com"><img class="brand-img" src="Assets/landing/logo-landing.png" /></a>
                </div>
                <div class="login-page-title">
                    Sign In to Trackado
                </div>
                <div class="login-form">
                    <div v-if="showLoginSection" class="login-page-description">Please enter your credentials to sign in.</div>

                    <div v-else class="verify-desc-text">
                        Enter the 6-digit code we sent to the phone number ending **{{user.phoneNumber}}. <br />
                        Didn't receive a code?
                        <a @click="goBackToLoginSection(true)" style="cursor: pointer; color: #54C08A">Start over to resend.</a>
                    </div>

                    <!-- Error message -->
                    <div v-if="isFaliedInvalidCredentials" class="login-fail-msg">
                        Wrong username or password, please try again.
                    </div>
                    <div v-if="isFaliedLockedCompany" class="login-fail-msg">
                        Your account is locked. Please contact us at<br><a href="mailto:support@trackado.com?Subject=My trackado account is locked" target="_top">support@trackado.com</a> to get help.
                    </div>
                    <div v-if="isFaliedLockedUser" class="login-fail-msg">
                        Your account has been locked for security reasons since we detected multiple failed sign-in attempts. Please reach out to your administrator or to our support.
                    </div>
                    <div v-if="isFaliedEnforceSso" class="login-fail-msg">
                        Your account requires SSO authentication. Please use the <a :href="'Sso/Login'">SSO sign-in</a> instead
                    </div>
                    <div v-if="isTwoFactorVerificationLimitExceeded" class="login-fail-msg">
                        You have reached the maximum amount of verification requests per day and cannot send any more requests for security reasons. Please contact our support if you think that this is an error or that your account has been breached!
                    </div>
                    <div v-if="isFalied2FA" class="login-fail-msg">
                        Wrong 2FA verification code, please try again.
                    </div>

                    <!-- Email and password section -->
                    <div v-if="showLoginSection">
                        <form id="frm-login" @submit.prevent="onSignInClick">
                            <div class="form-group form-material floating inp-error-marker">
                                <v-input-text :type="text"
                                              :label="'EMAIL'"
                                              :placeholder="'Email'"
                                              :value="user.email"
                                              @input="(val) => (user.email = val)"
                                              @focus="validation.forEmail = false"
                                              :required="true"
                                              :showError="validation.forEmail"
                                              :errorMessage="'Please insert email.'"></v-input-text>
                            </div>
                            <div class="form-group form-material floating inp-error-marker">
                                <v-input-text :type="'Password'"
                                              :label="'PASSWORD'"
                                              :placeholder="'Password'"
                                              :value="user.password"
                                              @input="(val) => (user.password = val)"
                                              @focus="validation.forPassword = false"
                                              :required="true"
                                              :showError="validation.forPassword"
                                              :errorMessage="'Please insert password.'"></v-input-text>
                            </div>

                            <!--Friendly captcha-->
                            <div v-if="!twoFAModal.isOpen" id="friendly-captcha"></div>

                            <button v-if="!isSignInClicked" type="submit" class="btn btn-success btn-block login-btn" id="submit-login-btn" :disabled="isSubmitBtnDisabled">SIGN IN</button>
                            <button v-else type="button" class="btn btn-success btn-block login-btn" id="submit-login-btn-loader" hidden><img class="loader-icon-gif" :src="'/Assets/loader.gif'" /></button>

                            <div class="form-group clearfix">
                                <div class="checkbox-custom checkbox-inline checkbox-default pull-left">
                                    <input type="checkbox" v-model="user.rememberMe">
                                    <label>Remember me</label>
                                </div>
                                <a class="pull-right forgot-password" :href="'Account/ForgotPassword'">Forgot Password?</a>
                            </div>
                            <p class="side-lines">
                                <span>OR</span>
                            </p>
                            <div class="form-group clearfix social-login">
                                <a class="btn btn-default pull-left" :href="'Sso/Google'">
                                    <img :src="'/Assets/icons/login.with.google.png'" />
                                    Sign in with Google
                                </a>
                                <a class="btn btn-default pull-right sign-with-social" :href="'Sso/Live'">
                                    <img :src="'/Assets/icons/login.with.microsoft.png'" />
                                    Sign in with Microsoft
                                </a>
                            </div>
                            <div class="form-group clearfix sso-login">
                                <a class="sign-with-sso" :href="'Sso/Login'">
                                    Sign in with SSO
                                </a>
                            </div>
                            <div>
                                <div class="login-page sign-up">
                                    Don't have an account?&nbsp;<a class="" :href="'Account/Registration'">Sign Up</a>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- Verification section -->
                    <div v-else>
                        <form id="frm-verify" @submit.prevent="onVerifyClick">
                            <div style="text-align: center;">
                                <code-input :loading="false" class="input" :type="number" v-on:complete="(value) => user.code = value" />
                                <label v-if="isVerifyValid" class="error-text">Please insert one digit in all of the fields.</label>
                            </div>

                            <button v-if="!isVerifyClicked" type="submit" class="btn btn-success btn-block login-btn verify-sign-in">SIGN IN</button>
                            <button v-else type="button" class="btn btn-success btn-block login-btn verify-sign-in" hidden><img class="loader-icon-gif" :src="'/Assets/loader.gif'" /></button>
                            <!-- Checkbox -->
                            <div class="checkbox-custom checkbox-inline checkbox-default pull-left verify-checkbox" v-if="showCheckboxFor30days">
                                <input type="checkbox" v-model="rememberTwoFactorAuthentication">
                                <label>Don't ask me again on this computer for 30 days.</label>
                            </div>
                            <br />
                            <p style="display: inline-flex;">Having trouble? <a style="cursor: pointer; margin-left:4px;" @click="backupCodeModal.isOpen = true">Use a backup code.</a></p>
                        </form>
                    </div>
                </div>

                <div v-if="showLoginSection" class="friendly-captcha-login-div">
                    <p class="friendly-captcha-login-p">This site is protected by <a href="https://friendlycaptcha.com/" target="_blank">Friendly Captcha</a></p>
                </div>
            </div>
        </div>

        <!-- Enter Backup code modal -->
        <v-modal @close="backupCodeModal.isOpen = false" :show="backupCodeModal.isOpen" :headerVisible="true" :size="'md'">
            <template v-slot:title>
                <div class="col-xs-12" style="margin-top: 30px; display: flex; text-align: center; margin-left: 58px; margin-bottom: 10px;">
                    <div class="site-menu-icon events-menu-icon section-icon">
                        <i class="icon-administer" aria-hidden="true"></i>
                    </div>
                    <h4 class="contract-section-title" style="color: #575b67; font-size: 32px; margin-top: 0px;">Enter back-up verification code</h4>
                </div>

            </template>
            <template v-slot:body>
                <div class="modal-content-wrapper">
                    <div class="form-group form-material floating inp-error-marker" style="width: 300px; margin-right: auto; margin-left: auto;">
                        <v-input-text :type="text"
                                      :label="'BACK-UP CODE'"
                                      :placeholder="'Back-up code'"
                                      :value="user.backupCode"
                                      @input="(val) => (user.backupCode = val)"
                                      @focus="isBackUpCodeValid = false"
                                      :required="true"
                                      :showError="isBackUpCodeValid"
                                      :errorMessage="'Please insert back-up code.'"></v-input-text>
                    </div>
                </div>
            </template>
            <template v-slot:buttons>
                <div style="text-align: center">
                    <button v-if="!isBackupCodeVerifyClicked" type="submit" class="btn btn-success btn-block login-btn backup-sign-in" @click="singInWithBackupCode">SIGN IN</button>
                    <button v-else type="button" class="btn btn-success btn-block login-btn backup-sign-in" hidden><img class="loader-icon-gif" :src="'/Assets/loader.gif'" /></button>
                </div>
            </template>
        </v-modal>

        <!-- Enable 2FA modal -->
        <v-modal @close="closeTwoFactorAuthModal" :show="twoFAModal.isOpen" :headerVisible="true" :size="'md'">
            <template v-slot:title>
                <div class="col-xs-12" style="margin-bottom: 8px;">
                    <div class="title-icon-wrap">
                        <div class="site-menu-icon events-menu-icon modal-title-icon modals-icon custom-icon-title">
                            <i class="icon-maintain-categories" aria-hidden="true"> </i>
                        </div>
                    </div>
                    <div v-if="verifyPhoneNumber" class="title-text-wap">
                        <span class="2fa-modal-title modals-title custom-text-title">Verify Your Mobile Number</span>
                    </div>
                    <div v-else class="title-text-wap">
                        <span class="2fa-modal-title modals-title custom-text-title">Enable Two-Factor Authentication</span>
                    </div>
                </div>

            </template>
            <template v-slot:body>
                <form class="model-body-mobile-number">
                    <div v-if="verifyPhoneNumber" class="verify-mobile-num-modal">
                        <div class="desc-text" style="align-items: center; text-align: center; padding-top: 20px;">
                            Enter the 6-digit code we sent to {{internationalMobileNumberFormat}} <br />
                            Didn't receive a code?
                            <a @click="submitMobileNumber" style="cursor: pointer; color: #54C08A">Resend.</a>
                        </div>
                        <div style="text-align: center;">
                            <code-input :loading="false" class="input" :type="number" v-on:complete="(value) => verificationCode = value" />
                            <label v-if="isVerifyValid" class="error-text">Please insert one digit in all of the fields.</label>
                        </div>
                    </div>
                    <div v-else class="add-mobile-num-modal">
                        <div class="desc-text">
                            Your account administrator has configured mandatory two-factor authentication for all users. Please update your phone number and we will text a verification code to this mobile device whenever you sign in to your account.
                        </div>
                        <div class="row">
                            <div class="col-xs-12 form-group form-material inp-error-marker mobile-number-select margin16">
                                <v-phone-number-input ref="mobileNumber"
                                                      :value="userPhoneNumber"
                                                      @input="onChangePhoneNumber"
                                                      @update="updatePhoneNumber"
                                                      :required="true"
                                                      :defaultCountryCode="userCountryCode"
                                                      @focus="focusOnNewMobileInput"
                                                      :showError="twoFAModalValidation.forPhoneNumber || isMobileFormatValid"
                                                      :errorMessage="isMobileFormatValid ? 'Incorrect format.' : 'Please insert a mobile number.'">

                                </v-phone-number-input>
                            </div>
                        </div>
                        <div class="desc-text">
                            By providing your mobile number, you agree to receive text messages from Trackado.
                        </div>
                        <div class="tfa-captcha" id="friendly-captcha"></div>
                    </div>
                </form>
            </template>
            <template v-slot:buttons>
                <div style="text-align: center">
                    <button v-if="verifyPhoneNumber"
                            id="verify-mobile-number-btn"
                            class="btn btn-base btn-editable btn-success confirm-btn"
                            type="button"
                            @click="verifySMScode">
                        <span class="icon-save modal-btn-icon-old" style="padding-right: 6px;"></span>CONFIRM
                    </button>
                    <button v-else id="submit-new-field-btn"
                            class="btn btn-base btn-editable btn-success confirm-btn"
                            type="button"
                            @click="submitMobileNumber">
                        <span class="icon-save modal-btn-icon-old" style="padding-right: 8px;"></span>CONFIRM PHONE NUMBER
                    </button>
                </div>
            </template>
        </v-modal>

        <!-- Backup codes modal -->
        <v-modal @close="backupCodesModal.isOpen = false" :show="backupCodesModal.isOpen" :headerVisible="true" :size="'md'" class="back-up-codes-modal">
            <template v-slot:title>
                <div class="title-icon-wrap">
                    <div class="site-menu-icon events-menu-icon modal-title-icon modals-icon custom-icon-title">
                        <i class="icon-administer" aria-hidden="true">
                        </i>
                    </div>
                </div>
                <div class="title-text-wap" style="margin-bottom: 10px;">
                    <span class="modals-title custom-text-title">Back-up verification codes</span>
                </div>

            </template>
            <template v-slot:body>
                <div class="modal-content-wrapper">
                    <p class="text-information">Back-up codes can be used in case you no longer have access to your mobile phone.</p>
                    <p class="text-information">Each code can be used once. We recommend you store them in a safe place.</p>

                    <div class="codes-section">
                        <div v-for="(pair, index) in backupCodesPairs" :key="'bc-' + index" class="row code-pairs">
                            <div class="col-sm-6 left-side">
                                <span :class="{'isUsed': pair.left.IsUsed }">{{ pair.left.Code }}</span>
                            </div>
                            <div class="col-sm-6 right-side" v-if="pair.right">
                                <span :class="{'isUsed': pair.right.IsUsed }">{{ pair.right.Code }}</span>
                            </div>
                        </div>
                        <p class="copy-codes" @click="copyCodesToClipboard">Copy codes to the clipboard.</p>
                    </div>
                    <!-- Hidden textarea for copy codes to clipboard -->
                    <textarea id="area-codes">{{ formattedCodes }}</textarea>
                </div>
                <!-- Checkbox for saving codes -->
                <div class="checkbox-custom checkbox-success"
                     style="margin: 25px 37px -15px;">
                    <input type="checkbox"
                           class="event-reminder-enable-cbx"
                           v-model="backupCodesModal.isCodesSaved" />
                    <label class="cbx-label">
                        I have saved my codes.
                        <span class="requred-input-indicator">*</span>
                    </label>
                </div>
            </template>
            <template v-slot:buttons>
                <div style="text-align: center">
                    <button class="btn btn-base btn-success btn-editable" type="submit" @click.prevent="activate2FA" :disabled="!backupCodesModal.isCodesSaved" style="margin-top: 6px;">
                        <span class="icon-save modal-btn-icon-old" style="margin-right: 6px; margin-left: -15px;"></span>ACTIVATE 2FA
                    </button>
                    <button class="btn btn-base btn-editable btn-edit" type="button" @click.prevent="backupCodesModal.isOpen = false">
                        <span class="icon-cancel modal-btn-icon-old" style="margin-right: 6px; margin-left: -15px;"></span>CANCEL
                    </button>
                </div>
            </template>
        </v-modal>

    </div>
</template>

<script>
    export default {
        name: "login-page",

        props: {
            options: Object,
        },
        data: () => {
            return {
                user: {
                    email: "",
                    password: "",
                    rememberMe: false,
                    code: null,
                    backupCode: null,
                    phoneNumber: ""
                },
                validation: {
                    forEmail: false,
                    forPassword: false,
                },
                backupCodeModal: {
                    isOpen: false,
                },
                // Flag for showing login or verification section
                showLoginSection: true,
                verificationCode: null,
                isVerifyValid: false,

                isBackUpCodeValid: false,

                isSignInClicked: false,
                isVerifyClicked: false,
                isBackupCodeVerifyClicked: false,

                showCheckboxFor30days: true,
                rememberTwoFactorAuthentication: false,
                isSubmitBtnDisabled: false,

                // Flags for error messages
                isFaliedLockedCompany: false,
                isFaliedLockedUser: false,
                isFaliedEnforceSso: false,
                isFaliedInvalidCredentials: false,
                isFalied2FA: false,
                isTwoFactorVerificationLimitExceeded: false,

                // Global 2FA
                isGlobal2FAEnabled: false,
                twoFAModal: {
                    isOpen: false,
                },
                isMobileValid: null,
                isMobileFormatValid: false,
                twoFAModalValidation: {
                    forPhoneNumber: false,
                },
                isPhoneNumberPreviouslySet: 0,
                userPhoneNumber: null,
                userCountryCode: null,
                internationalMobileNumberFormat: null,
                verifyPhoneNumber: false,
                verificationCode: null,
                isVerifyValid: false,

                backupCodesModal: {
                    isOpen: false,
                    isCodesSaved: false,
                    backupCodes: [],
                },
            }
        },
        computed: {
            backupCodesPairs: function () {
                var pairs = [];
                for (var i = 0; i < this.backupCodesModal.backupCodes.length; i += 2) {
                    pairs.push({
                        left: this.backupCodesModal.backupCodes[i],
                        right: this.backupCodesModal.backupCodes.length > i ? this.backupCodesModal.backupCodes[i + 1] : null
                    });
                }
                return pairs;
            },

            formattedCodes() {
                var backupCodesFormatted = this.backupCodesModal.backupCodes.map(x => { return x.Code });
                return backupCodesFormatted.join("\n");
            },
        },
        methods: {
            isValid() {
                var isValid = true;

                if (this.user.email == "" || this.user.email == null) {
                    this.validation.forEmail = true;
                    isValid = false;
                }
                if (this.user.password == "" || this.user.password == null) {
                    this.validation.forPassword = true;
                    isValid = false;
                }
                return isValid;
            },

            isVerifyCodeModalValid() {
                var isValid = true;
                if (this.user.code == null) {
                    this.isVerifyValid = true;
                    isValid = false;
                }
                return isValid;
            },

            isBackupCodeVerifyModalValid() {
                var isValid = true;
                if (this.user.backupCode == null) {
                    this.isBackUpCodeValid = true;
                    isValid = false;
                }
                return isValid;
            },

            goBackToLoginSection(resendCode) {
                if (resendCode == false) {
                    this.user.email = "";
                }
                this.user.password = "";
                this.user.code = null;
                this.user.backupCode = null;
                this.isSubmitBtnDisabled = false;
                this.isSignInClicked = false;
                this.showLoginSection = true;
                this.isFaliedLockedCompany = false;
                this.isFaliedLockedUser = false;
                this.isFaliedEnforceSso = false;
                this.isFaliedInvalidCredentials = false;
                this.isTwoFactorVerificationLimitExceeded = false;
                this.isFalied2FA = false;
                this.isVerifyClicked = false;
                this.isBackupCodeVerifyClicked = false;
                // Reload friendly captcha
                setTimeout(function () {
                    friendlyCaptchaLoadedCallback();
                }, 300);
            },

            onSignInClick() {
                if (this.isValid()) {
                    this.isSignInClicked = true;
                    gtagex('event', 'Sign-in_form_submitted', { event_category: "Sign-In", event_label: "Sign-In" });
                    var model = {};
                    if (this.options.withCaptcha) {

                        model = {
                            Email: this.user.email,
                            Password: this.user.password,
                            RememberMe: this.user.rememberMe,
                            ReturnUrl: this.options.returnUrl,
                            CaptchaToken: window.friendlyChallenge.solution,
                        };
                    } else {
                        model = {
                            Email: this.user.email,
                            Password: this.user.password,
                            RememberMe: this.user.rememberMe,
                            ReturnUrl: this.options.returnUrl
                        };
                    }
                    app.api.Account.login(
                        model,
                        (loginData) => {
                            localStorage.setItem("showWelcomeMessage", true);
                            localStorage.setItem("unknownUserModalDisplayed", JSON.stringify(false));
                            var redirectUrl = loginData.redirectUrl;
                            var baseHost = "https://" + window.location.host;
                            var url = baseHost + redirectUrl;
                            top.location.href = url;
                        },
                        (data) => {
                            this.isFaliedInvalidCredentials = false;
                            this.isFaliedLockedCompany = false;
                            this.isFaliedLockedUser = false;
                            this.isFaliedEnforceSso = false;
                            this.isFalied2FA = false;
                            this.isTwoFactorVerificationLimitExceeded = false;

                            if (window.friendlyChallenge.customWidget) {
                                window.friendlyChallenge.customWidget.reset();
                                this.isSubmitBtnDisabled = true;
                                this.isSignInClicked = false;
                            }
                            if (!data) {
                                return;
                            }
                            if (data.isCompanyLocked) {
                                this.isFaliedLockedCompany = true;
                            }
                            else if (data.isUserLocked) {
                                this.isFaliedLockedUser = true;
                            }
                            else if (data.enforceSso) {
                                this.isFaliedEnforceSso = true;
                            }
                            else if (data.exceededTwoFactorVerificationLimit) {
                                this.isTwoFactorVerificationLimitExceeded = true;
                            }
                            else if (data.twoFactorVerificationRequired) {
                                // Hide login form, show flow for verifying code (2FA)
                                this.showLoginSection = false;
                                // Check if show codes should be shown (for system administrator is hidden)
                                this.showCheckboxFor30days = data.showBackupCodes;
                                this.user.phoneNumber = data.twoFactorVerificationPhoneLastDigits;
                            }
                            else {
                                this.isFaliedInvalidCredentials = true;
                            }
                            // Global 2FA
                            if (data.shouldEnable2Fa) {
                                this.isGlobal2FAEnabled = true;
                                this.twoFAModal.isOpen = true;
                                this.isFaliedInvalidCredentials = false;
                                setTimeout(() => {
                                    friendlyCaptchaLoadedCallback();
                                }, 100);
                            }
                        }
                    );
                }

            },

            onVerifyClick() {
                if (this.isVerifyCodeModalValid()) {
                    this.isVerifyClicked = true;
                    app.notifications.showLoading("Verifying...");
                    var model = {
                        Email: this.user.email,
                        Password: this.user.password,
                        RememberMe: this.user.rememberMe,
                        RememberTwoFactorAuthentication: this.rememberTwoFactorAuthentication,
                        TwoFactorAuthenticationVerificationCode: this.user.code,
                        TwoFactorAuthenticationBackupCode: null,
                        ReturnUrl: this.options.returnUrl,
                        ShouldSkipIsVerified: false,
                        CaptchaToken: window.friendlyChallenge.solution,
                    };
                    app.api.Account.loginWithTwoFactorAuthenticationConfirmation(
                        model,
                        (verifyData) => {
                            app.notifications.hideLoading();
                            app.notifications.showSuccesfulMsg("Mobile number was successfully verified.");

                            localStorage.setItem("showWelcomeMessage", true);
                            localStorage.setItem("unknownUserModalDisplayed", JSON.stringify(false));
                            var redirectUrl = verifyData.redirectUrl;
                            var baseHost = "https://" + window.location.host;
                            var url = baseHost + redirectUrl;
                            top.location.href = url;
                        },
                        (err) => {
                            app.notifications.hideLoading();
                            app.notifications.showErrorMsg("Failed to verify.");

                            this.isFalied2FA = true;
                            this.goBackToLoginSection(false);
                        }
                    );
                };
            },

            singInWithBackupCode() {
                if (this.isBackupCodeVerifyModalValid()) {
                    this.isBackupCodeVerifyClicked = true;
                    app.notifications.showLoading("Verifying...");
                    var model = {
                        Email: this.user.email,
                        Password: this.user.password,
                        RememberMe: this.user.rememberMe,
                        RememberTwoFactorAuthentication: this.rememberTwoFactorAuthentication,
                        TwoFactorAuthenticationVerificationCode: null,
                        TwoFactorAuthenticationBackupCode: this.user.backupCode,
                        ReturnUrl: this.options.returnUrl,
                        ShouldSkipIsVerified: false,
                        CaptchaToken: window.friendlyChallenge.solution,
                    };

                    app.api.Account.loginWithTwoFactorAuthenticationConfirmation(
                        model,
                        (verifyData) => {
                            app.notifications.hideLoading();
                            app.notifications.showSuccesfulMsg("Back-up code was successfully verified.");
                            this.backupCodeModal.isOpen = false;
                            localStorage.setItem("showWelcomeMessage", true);
                            localStorage.setItem("unknownUserModalDisplayed", JSON.stringify(false));
                            var redirectUrl = verifyData.redirectUrl;
                            var baseHost = "https://" + window.location.host;
                            var url = baseHost + redirectUrl;
                            top.location.href = url;
                        },
                        (err) => {
                            app.notifications.hideLoading();
                            app.notifications.showErrorMsg("Failed to verify.");

                            this.backupCodeModal.isOpen = false;
                            this.isFalied2FA = true;
                            this.goBackToLoginSection(false);
                        }
                    );
                }
            },

            onChangePhoneNumber(val) {
                if (this.isPhoneNumberPreviouslySet >= 3) {
                    this.userPhoneNumber = val;
                }
            },

            updatePhoneNumber(phoneNumberObj) {
                if (this.isPhoneNumberPreviouslySet < 3) {
                    this.isPhoneNumberPreviouslySet++;
                    this.userPhoneNumber = phoneNumberObj.formatNational;
                }
                this.isMobileValid = phoneNumberObj.isValid;
                this.phoneCountryCode = phoneNumberObj.countryCode;
                this.internationalMobileNumberFormat = phoneNumberObj.e164;
            },

            focusOnNewMobileInput() {
                this.twoFAModalValidation.forPhoneNumber == true
                    ? (this.twoFAModalValidation.forPhoneNumber = false)
                    : (this.isMobileFormatValid = false)
                setTimeout(() => {
                    this.$refs.mobileNumber.$children[0].$refs.PhoneNumberInput.focusInput(); // access the ref and make it focus after a delay make sure element appears in the DOM
                }, 200);
            },

            is2FAMobileNumberValid() {
                var valid = true;
                if (!this.userPhoneNumber) {
                    this.twoFAModalValidation.forPhoneNumber = true;
                    valid = false;
                } else {
                    this.twoFAModalValidation.forPhoneNumber = false;
                }
                if (!this.isMobileValid && this.userPhoneNumber != "") {
                    this.isMobileFormatValid = true;
                    valid = false;
                }
                return valid;
            },

            isVerifyModalValid() {
                if (!this.verificationCode) {
                    this.isVerifyValid = true;
                    return false;
                } else {
                    this.isVerifyValid = false;
                    return true;
                }
            },

            submitMobileNumber() {
                var model = {
                    Email: this.user.email,
                    Password: this.user.password,
                    PhoneNumber: this.internationalMobileNumberFormat,
                };
                var valid = this.is2FAMobileNumberValid();

                if (valid) {
                    app.notifications.showLoading("Sending...");
                    app.api.UserProfile.updateTwoFactorAuthenticationForAnonymous(
                        model,
                        function () {
                            app.notifications.hideLoading();
                            app.notifications.showSuccesfulMsg("Verification SMS was successfully sent.");
                            this.verifyPhoneNumber = true;
                        }.bind(this),
                        function (err) {
                            app.notifications.hideLoading();
                            app.Error.displayErrorMsg(
                                err
                            );
                        }.bind(this)
                    );
                }
            },

            verifySMScode() {
                var model = {
                    Email: this.user.email,
                    PhoneNumber: this.internationalMobileNumberFormat,
                    PhoneCountryCode: this.phoneCountryCode,
                    VerificationCode: this.verificationCode,
                };
                if (this.isVerifyModalValid()) {
                    app.notifications.showLoading("Verifying...");
                    app.api.UserProfile.verifySmsForTwoFactorAuthenticationForAnonymous(
                        model,
                        (response) => {
                            this.backupCodesModal.backupCodes = response;

                            app.notifications.hideLoading();
                            app.notifications.showSuccesfulMsg("Mobile number was successfully verified.");

                            this.twoFAModal.isOpen = false;
                            this.backupCodesModal.isOpen = true;
                        },
                        (error) => {
                            app.notifications.hideLoading();
                            app.Error.displayErrorMsg(error);
                        }
                    );
                }
            },

            copyCodesToClipboard() {
                var copyText = document.getElementById("area-codes");
                /* Select the text field */
                copyText.select();
                copyText.setSelectionRange(0, 99999);
                /* Copy the text inside the text field */
                navigator.clipboard.writeText(copyText.value);
                app.notifications.showSuccesfulMsg("Back-up codes are copied to clipboard.");
            },

            activate2FA() {
                app.notifications.showLoading("Loading...");
                var model = {
                    Email: this.user.email,
                    Password: this.user.password,
                    BackupCodes: this.backupCodesModal.backupCodes.map(x => { return x.Code })
                };
                app.api.UserProfile.activateTwoFactorAuthenticationForAnonymous(
                    model,
                    (response) => {
                        app.notifications.hideLoading();
                        this.backupCodesModal.isOpen = false;

                        localStorage.setItem("showWelcomeMessage", true);
                        localStorage.setItem("unknownUserModalDisplayed", JSON.stringify(false));
                        var url = "https://" + window.location.host;
                        top.location.href = url;
                    },
                    () => {
                        app.notifications.hideLoading();
                        app.notifications.showErrorMsg("Failed to sign in.");
                    }
                );
            },
            closeTwoFactorAuthModal() {
                this.twoFAModal.isOpen = false;
                setTimeout(() => {
                    friendlyCaptchaLoadedCallback();
                }, 100);
            }
        },

        mounted() {
            $('.sign-in-wrapper').css("-moz-transform", "translatez(0)");

            window.addEventListener('keydown', (e) => {
                if (e.key == 'Enter') {
                    if (this.verifyPhoneNumber && this.twoFAModal.isOpen) {
                        this.verifySMScode();
                    }
                }
            });
        },
    }

</script>

<style scoped>
    #login-page {
        padding-top: 8rem;
    }

        #login-page .verify-desc-text {
            font-size: 16px;
        }

        #login-page .verify-sign-in {
            margin-top: 20px;
        }

    .site-menu-icon.events-menu-icon {
        background-color: #54c08a;
    }

    .modal-title-icon {
        display: inline-block;
        text-align: center;
    }

    .form-max-width {
        max-width: 400px;
    }

    .site-menu-icon {
        width: 36px !important;
        height: 36px !important;
        -webkit-border-radius: 50%;
        color: #fff !important;
        font-size: 15px;
        overflow: hidden;
        line-height: 41px;
    }

    [class^="icon-"], [class*=" icon-"] {
        font-family: 'trackado-icon-font' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
    }

    @media screen and (max-width: 390px) {
        #login-page .social-login {
            display: grid;
        }

            #login-page .social-login .btn {
                width: 100%;
                margin-bottom: 15px;
            }
    }

    .copy-codes {
        color: #54c08a;
        text-align: center;
        cursor: pointer;
        margin-top: 20px;
    }

        .copy-codes:active {
            color: #8adca4;
        }

    .codes-section {
        text-align: center;
    }

        .codes-section .code-pairs {
            margin-left: 65px;
            margin-right: 65px;
        }

            .codes-section .code-pairs .left-side span,
            .codes-section .code-pairs .right-side span {
                font-weight: 500;
                font-size: 16px;
            }

            .codes-section .code-pairs .left-side .isUsed,
            .codes-section .code-pairs .right-side .isUsed {
                text-decoration: line-through;
                color: #97a8b69e;
            }

    #login-page #area-codes {
        display: none;
    }
</style>

<style>
    .tfa-captcha .frc-text,
    .tfa-captcha .frc-button {
        color: #000 !important;
    }

    #login-page .modal-dialog {
        margin: 80px auto !important;
    }

    #login-page #frm-login .floating-label {
        left: -2px;
    }

    #login-page .login-form .loader-icon-gif {
        width: 160px;
        margin-top: -40px;
    }

    #login-page .verify-checkbox {
        margin-left: 40px;
        margin-bottom: 25px;
    }


    #login-page .modal-content-wrapper .floating-label {
        position: absolute;
        top: 99px;
        left: 10px;
    }

    #login-page .modal-content-wrapper .requred-input-indicator {
        top: 85px;
    }

    #login-page .modal-content-wrapper .icon-input-error {
        top: 100px;
    }

    #login-page .modal-content .backup-sign-in {
        width: 200px;
        margin-left: auto;
        margin-right: auto;
    }

        #login-page .modal-content .backup-sign-in .loader-icon-gif {
            width: 165px;
        }

    /* Start verification code input style  */
    #login-page .react-code-input-container {
        width: 100% !important;
        display: flex !important;
        justify-content: center !important;
        margin-top: 20px !important;
    }

    #login-page .react-code-input > input {
        box-shadow: unset !important;
        font-family: "proxima-nova" !important;
        color: #6A7992 !important;
        font-size: 16px !important;
    }

        #login-page .react-code-input > input:focus {
            border: 1px solid #54c08a !important;
        }
    /* End verification code input style  */

    #login-page .login-form .login-fail-msg {
        display: inline;
    }

    #login-page .react-code-input > input:first-child {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }

    #login-page .react-code-input > input:last-child {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }

    #login-page .requred-input-indicator {
        right: 8px !important;
    }

    #login-page .add-mobile-num-modal {
        margin: 0px 40px 0 40px;
    }

    #login-page .model-body-mobile-number .add-mobile-num-modal .phone-input-wrapper .dots-text {
        font-size: 14px !important;
        text-align: justify !important;
        color: #6a7992 !important;
        font-weight: 300 !important;
    }

    #login-page .model-body-mobile-number .margin16 {
        margin-top: 16px;
        margin-bottom: 16px;
    }

    #login-page .content-right-panel .mobile-number-container .input-button.edit {
        right: 24px;
    }

    #login-page .model-body-mobile-number .desc-text {
        font-size: 17px;
        text-align: justify;
        color: #6a7992;
        font-weight: 300;
    }

    #login-page .model-body-mobile-number .SMSArea {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        margin-top: 20px;
    }

        #login-page .model-body-mobile-number .SMSArea div:nth-child(1) input,
        #login-page .model-body-mobile-number .SMSArea div:nth-child(5) input {
            border-bottom-left-radius: 6px;
            border-top-left-radius: 6px;
        }

        #login-page .model-body-mobile-number .SMSArea div:nth-child(3) input,
        #login-page .model-body-mobile-number .SMSArea div:nth-child(7) input {
            border-bottom-right-radius: 6px;
            border-top-right-radius: 6px;
        }

        #login-page .model-body-mobile-number .SMSArea div input {
            height: 48px;
            width: 40px;
            border: 1px solid #97a8b6;
        }

            #login-page .model-body-mobile-number .SMSArea div input:focus {
                outline: none;
            }

    .number-format .my-vselect .v-select.select-single .vs__dropdown-menu,
    .date-format .my-vselect .v-select.select-single .vs__dropdown-menu {
        height: 250px !important;
    }

    .date-format
    .v-select.vs--searchable
    .vs__dropdown-toggle
    .vs__selected-options
    .vs__search.focus-visible,
    .number-format
    .v-select.vs--searchable
    .vs__dropdown-toggle
    .vs__selected-options
    .vs__search.focus-visible,
    .day-of-the-week
    .v-select.vs--searchable
    .vs__dropdown-toggle
    .vs__selected-options
    .vs__search.focus-visible,
    #login-page
    .mobile-number-select
    .v-select.vs--searchable
    .vs__dropdown-toggle
    .vs__selected-options
    .vs__search.focus-visible,
    .page-size-dropdown
    .v-select.vs--searchable
    .vs__dropdown-toggle
    .vs__selected-options
    .vs__search.focus-visible {
        width: 100px;
    }

    /* Start verification code input style  */
    #login-page .react-code-input-container {
        width: 100% !important;
        display: flex !important;
        justify-content: center !important;
        margin-top: 20px !important;
    }

    #login-page .react-code-input > input {
        box-shadow: unset !important;
        font-family: "proxima-nova" !important;
        color: #6A7992 !important;
        font-size: 16px !important;
    }

        #login-page .react-code-input > input:focus {
            border: 1px solid #54c08a !important;
        }

    #login-page
    .content-right-panel
    .mobile-number-container
    .form-material
    .form-control:disabled,
    #login-page
    .content-right-panel
    .mobile-number-container
    .form-material
    .form-control[disabled],
    #login-page
    .content-right-panel
    .mobile-number-container
    fieldset[disabled]
    .form-material
    .form-control {
        background-color: white !important;
    }
    /* End verification code input style  */

    #login-page .back-up-codes-modal .modal-content-wrapper {
        color: #97a8b6;
        text-align: center;
    }

    #login-page .back-up-codes-modal .requred-input-indicator {
        right: -16px !important;
    }

    #login-page .back-up-codes-modal .modal-body .checkbox-custom.checkbox-success .cbx-label {
        color: #97a8b6;
    }
</style>



// WEBPACK FOOTER //
// LoginPage.vue?25e2aeae